export default __webpack_public_path__ + "static/media/miguel-lopes-11.20763b2f.jpg";